/* Keep off-screen product cards out of keyboard and agent navigation. */
(() => {
  const observed = new WeakSet();
  function sync(card) { card.inert = card.getAttribute('aria-hidden') === 'true'; }
  function bind(root) {
    const sliders = root.matches?.('.flickity-slider') ? [root] : [];
    sliders.push(...root.querySelectorAll('.flickity-slider'));
    sliders.forEach(slider => {
      if (observed.has(slider)) return;
      observed.add(slider);
      slider.querySelectorAll(':scope > .yv-product-card').forEach(sync);
      new MutationObserver(changes => {
        changes.forEach(change => {
          if (change.type === 'attributes' && change.target.matches('.yv-product-card')) sync(change.target);
          if (change.type === 'childList') slider.querySelectorAll(':scope > .yv-product-card').forEach(sync);
        });
      }).observe(slider, {attributes:true, attributeFilter:['aria-hidden'], childList:true, subtree:true});
    });
  }
  bind(document);
  new MutationObserver(changes => changes.forEach(change => change.addedNodes.forEach(node => {
    if (node.nodeType === 1) bind(node);
  }))).observe(document.body, {childList:true, subtree:true});
})();
